import { Component, Input } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { AssetStoragePermissionGroupDTO } from 'src/app/base/models/models.swagger.generated';
import { TranslateModule } from '@ngx-translate/core';
import { AppErrorMessagesComponent } from '../../../../base/error-messages/app-error-messages.component';


@Component({
    selector: 'app-permission-group-form',
    templateUrl: './permission-group-form.component.html',
    styleUrls: ['./permission-group-form.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, TranslateModule]
})
export class PermissionGroupFormComponent {

  @Input()
  public permissionGroupForm: UntypedFormGroup;

  @Input()
  public permissionGroup: AssetStoragePermissionGroupDTO;

  constructor() { }
}
